<template>
  <div class="chart-widget">
    <v-row class="select-row">
      <v-col cols="12" class="select-col">
        <v-select
          v-model="type"
          :items="types"
          label="Tipo"
          prepend-inner-icon="mdi-format-list-bulleted-type"
          filled
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="chart-row">
      <SimplePie
        v-if="chart"
        :value="chart"
        id="historic-orders"
      />
    </v-row>
  </div>
</template>

<script>
import SimplePie from '@/components/charts/apex/SimplePie'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { SimplePie },
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    types: [
      {
        text: 'Categorias',
        value: 'categories'
      },
      {
        text: 'Sub-Categorias',
        value: 'sub-categories'
      },
      {
        text: 'Tipo de Entrega',
        value: 'type'
      },
      {
        text: 'Mais Vendidos',
        value: 'best-sellers'
      }
    ],
    type: 'categories'
  }),
  computed: {
    data () {
      return (this.customData ? (this.socketInfo.custom_data ? this.socketInfo.custom_data.orders : []) : (this.get_data ? this.get_data.orders : []))
    },
    chart () {
      switch (this.type) {
        case 'categories':
          return this.catChart()
        case 'sub-categories':
          return this.subcatChart()
        case 'type':
          return this.typeChart()
        case 'best-sellers':
          return this.bestsellersChart()
        default:
          return []
      }
    }
  },
  methods: {
    catChart () {
      let chart = []
      let categories = this.get_data.categories || []
      const data = categories.filter((el) => el.parent === 0)
      data.forEach(function (obj) {
        let output = this.data.filter(el => {
          return el.order.some((a) => a.list
            .some((b) => b.parent_cat === obj.id)
          )
        })
        if (output.length > 0) chart.push({ title: obj.name, value: output.length })
      }.bind(this))
      let sorted = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      return filtered
    },
    subcatChart () {
      let chart = []
      let subcategories = this.get_data.categories || []
      const data = subcategories.filter((el) => el.parent !== 0)
      data.forEach(function (obj) {
        let output = this.data.filter(el => {
          return el.order.some((a) => a.list
            .some((b) => b.cat === obj.id)
          )
        })
        if (output.length > 0) chart.push({ title: obj.name, value: output.length })
      }.bind(this))
      let sorted = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      return filtered
    },
    typeChart () {
      let chart = []
      let groups = this.data.reduce(function (r, a) {
        r[a.type] = r[a.type] || []
        r[a.type].push(a)
        return r
      }, [])
      if (groups) {
        let types = this.get_global.defaults.options.orders.types
        groups.forEach(function (obj, i) {
          let type = types.find(el => el.id === i)
          let title = type.title
          chart.push({ title, value: obj.length })
        })
      }
      let sorted = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      return filtered
    },
    bestsellersChart () {
      let chart = []
      const data = this.data.map((el) => (el.order || []).map((ord) => ord.list).reduce((add, val) => add.concat(val), []))
      const flatten = data.reduce((add, val) => add.concat(val), [])
      let group = flatten.reduce((r, a) => {
        r[a.id] = { id: a.id, title: a.title, value: (r[a.id] ? (parseInt((r[a.id].value) || 0) + parseInt(a.qty)) : parseInt(a.qty)) }
        return r
      }, [])
      let sorted = group.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      if (filtered.length > 0) chart = [ ...filtered ]
      return chart
    }
  }
}
</script>
